import UncategorizedDocuments from "./uncategorized-documents";

export default UncategorizedDocuments;
